import BaseService from '@/shared/services/core/base.service';
import { SERVICE_NAMES } from '@/shared/services/core/service-names';

class AppVersionService extends BaseService {
  async getVersion() {
    const response = await this.repository.getVersion();
    return this.handleResponse(response);
  }
}

export default new AppVersionService(SERVICE_NAMES.APP_VERSION);
